import type { ScalarGuideElement } from '@/types'
import { attributesCalloutSchema, type AttributesCallout } from './attributes'
import { validate } from '@/helpers/validate'
import { guideCalloutHtml } from '@/elements/callout/component'
export type { AttributesCallout } from './attributes'
export { CalloutType } from './attributes'
export { ScalarCalloutVue } from './component'

export const scalarCallout: ScalarGuideElement<
  AttributesCallout,
  'scalar-callout'
> = {
  name: 'scalar-callout',
  tagName: 'scalar-callout',
  tiptapName: 'callout',
  attributeTransform: (_, attrs) => {
    return validate(attributesCalloutSchema, {
      ...attrs,
      icon:
        typeof attrs.icon === 'string'
          ? attrs.icon
          : typeof (attrs.icon as any)?.src === 'string'
            ? (attrs.icon as any)?.src
            : '',
      // Handle legacy `calloutType` attribute
      type: attrs.type || attrs.calloutType || 'neutral',
    })
  },

  render: async (props) => {
    const transformed = scalarCallout.attributeTransform('', props)

    return transformed ? guideCalloutHtml(transformed) : ''
  },
}
